import { render, staticRenderFns } from "./printFile.vue?vue&type=template&id=50b5283b&scoped=true&"
import script from "./printFile.vue?vue&type=script&lang=js&"
export * from "./printFile.vue?vue&type=script&lang=js&"
import style0 from "./printFile.vue?vue&type=style&index=0&id=50b5283b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5283b",
  null
  
)

export default component.exports